import { cases, type CaseItem } from "@/mocks/cases";

export const getCaseById = (id: string): CaseItem | undefined =>
  cases.find((item) => item.id === id);

export const getFeaturedCases = (): CaseItem[] => {
  const featured = cases.filter((item) => item.featured);
  return featured.length > 0 ? featured : cases.slice(0, 3);
};

export const getRelatedCases = (current: CaseItem, limit = 3): CaseItem[] => {
  const sameCategory = cases.filter(
    (item) => item.id !== current.id && item.category === current.category,
  );
  const others = cases.filter(
    (item) => item.id !== current.id && item.category !== current.category,
  );
  return [...sameCategory, ...others].slice(0, limit);
};

export const getLatestCases = (limit = 6): CaseItem[] =>
  [...cases].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, limit);